module.exports = __webpack_public_path__ + "img/pmsm3.3a8f807d.png";